import { useStore } from 'effector-react'

import {
  $settingCountryList,
  $totalCountOfSettingCountryList,
  getSettingCountryList,
  SettingCountryListMounted,
} from './model'
import { SettingCountryListRequest } from './types'

export const useSettingCountryList = () => {
  const settingCountryList = useStore($settingCountryList)

  const loading = useStore(getSettingCountryList.pending)

  const totalCountOfSettingCountryList = useStore(
    $totalCountOfSettingCountryList,
  )

  const onChangeSettingCountryList = ({
    orderBy,
    orderDirection,
  }: SettingCountryListRequest) => {
    SettingCountryListMounted({
      orderBy,
      orderDirection,
    })
  }

  return {
    settingCountryList,
    totalCountOfSettingCountryList,
    loading,
    onChangeSettingCountryList,
  }
}
